import { ChangeDetectorRef, Directive, OnDestroy, Optional } from '@angular/core';
import { AccountEditComponentDef } from '@df/account/account-edit.component.def';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { AccountViewComponent } from './../../view/account-view.component';
@Directive({})
// tslint:disable-next-line: directive-class-suffix
export abstract class AbstractEditFormComponent extends AccountEditComponentDef implements OnDestroy {
    constructor(private accountViewComponent: AccountViewComponent, ref: ChangeDetectorRef, 
    @Optional()
    private modalRef: ModalRef<AbstractEditFormComponent>) {
        super(ref);
        this.accountViewComponent.forceContentCols = 5;
    }
    ngOnDestroy(): void {
        this.accountViewComponent.forceContentCols = undefined;
        super.ngOnDestroy();
    }
    close() {
        if (this.modalRef) {
            this.modalRef.close();
        }
        else {
            this.router.navigateByUrl('/account/edit');
        }
    }
    onSubmitSuccess() {
        this.close();
        super.onSubmitSuccess();
    }
}
